<template>
  <div>
    <!--  微信登录-->
    <el-dialog :visible.sync="dialogVisible" width="400px" center :close-on-click-modal="false"
      @closed="handleDialogClose">
      <div class="content">
        <div class="title">企业微信登录</div>
        <p>请使用手机企业微信扫描下方二维码</p>
        <!-- 二维码登录 -->
        <div id="wxqr-container"></div>
        <div class="rakumart">
          RAKUMART-订单系统
        </div>
      </div>
    </el-dialog>
    <!-- 选择账号 -->
    <el-dialog :visible.sync="userDialogVisible" width="400px" center :close-on-click-modal="false">
      <div class="content">
        <div class="title">选择账号</div>
        <div class="row" v-for="(item, index) in userLogin" :key="index">
          <el-radio v-model="radio" :label="index">
            <img :src="item.userInfo.pic" alt="">
            {{ item.userInfo.realname }}
          </el-radio>
        </div>
        <div class="btn">
          <el-button type="primary" @click="selectLogin">登录该账号</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      show: false,
      userLogin: [],
      userDialogVisible: false,
      radio: '',
    };
  },
  methods: {
    // 生成企业微信登录二维码
    generateQrCode() {
      this.radio = ''
      // 初始化登录组件
      // container.innerHTML = ''; // 清空容器
      let that = this
      const wwLogin = ww.createWWLoginPanel({
        params: {
          login_type: 'CorpApp',
          appid: 'ww79e73acf2785a242',
          agentid: '1000055',
          redirect_uri: 'https://manage.rakumart.com',
          redirect_type: 'callback',
        },
        onCheckWeComLogin({ isWeComLogin }) {
          console.log(isWeComLogin)
        },
        onLoginSuccess({ code }) {
          let datas = {
            code,
            system: 1
          }
          //企业微信绑定提交接口
          that.$api.wxLogin(datas).then(res => {
            if (res.data == false) return this.$message.error('未绑定企业微信，请登录账号后绑定')
            if (res.data.length == 1) {
              that.login(res.data[0])
            } else {
              that.userLogin = res.data
              that.userDialogVisible = true
            }
          })
          console.log({ code }, '成功')
        },
        onLoginFail(err) {
          console.log(err, '失败')
        },
      })
      // 显示企业微信扫码
      this.$nextTick(() => {
        const container = document.getElementById('wxqr-container');
        container.appendChild(wwLogin.el)
      })
      // console.log(wwLogin.el);
    },
    // 选择账号登录
    selectLogin() {
      if (this.radio === '') return this.$message.error('请选择要登录的账号')
      this.login(this.userLogin[this.radio])
    },
    // 登录
    login(data) {
      localStorage.setItem("japan_access_token", data.access_token);
      document.cookie = `japan_access_token=${data.access_token} ${data.userInfo.id}`;
      localStorage.setItem(
        "japanUserRoleInfo",
        JSON.stringify(data.userInfo)
      );
      localStorage.setItem(
        "japanUserRoleStatus",
        data.userInfo.role[0].work_type
      );
      // 验证过的手机号 不删除，保留
      if (data.compute_token) {
        localStorage.setItem("compute_token", data.compute_token);
      }
      this.$store.dispatch("userAuth");
      this.$store.dispatch("getMenu");
      this.$router.replace("/homePage");
      this.dialogVisible = false
      this.userDialogVisible = false
    },
    // 弹窗关闭时清理
    handleDialogClose() {
      const container = document.getElementById('wxqr-container');
      const iframe = document.querySelector('iframe');
      container.removeChild(iframe)
    }
  },
}
</script>
<style lang='scss' scoped>
.content {
  padding-bottom: 20px;
  color: #1A1A1A;

  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  p {
    margin-bottom: 30px;
    text-align: center;
    font-size: 16px;
  }

  .row {
    margin: 0 20px 30px;

    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin: 0 10px;
      vertical-align: middle;
    }

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  .btn {
    text-align: center;
  }

  .rakumart {
    margin-top: 20px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  #wxqr-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
  }


}
</style>